import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
import ManufacturePic from "../../Images/Investor/ManufacturePic.png";

const GoToMarket: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Go To Market" />
      <SubSection>
        <ImageComp imageSource={ManufacturePic} width={"Clamp(18rem, 25vw, 36rem)"} />
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">With any one of our USPs we offer value:</h4>
            <ul>
              <li>Greater fuel efficiency</li>
              <li>Higher power to weight</li>
              <li>Longer lasting and low maintenance</li>
              <li>Easier to manufacture</li>
              <li>Greener with better emissions</li>
              <li>Flex-fuel capabilities</li>
            </ul>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">$2.1T addressable market</h4>
            <p className="inv-item-body">
              103 manufacturers make up $2.1T of the $3T market, with median & average revenues of
              $4B and $21B.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Accessible pricing, known targets</h4>
            <p className="inv-item-body">
              Our fees are well "within reach," ensuring costs are never barriers, and we know our
              target clients.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Proven traction</h4>
            <p className="inv-item-body">We already have 2 producer IP rights agreements.</p>
          </div>
        </div>
      </SubSection>
    </div>
  );
};

export default GoToMarket;
